module.exports = __webpack_public_path__ + "media/images/mypage/icon/black/ico_money-7de543fec7e947bb889a2c293197f7d4.svg";